var XPortal = XPortal || {};
XPortal.Calendar = (function () {

    var self = {
        calendarData: {},
        MS_PER_DAY: 86400000,
        NS: '.kendoMonthView',
        weekCountItems: 0,
        dayCountItems: 0,
        resizeTimeout: null,
        startDayHour: 8,
        endDayHour: 17,
        dictionaryOptions: {},

        bindEvents: function ($scheduler) {
            $scheduler.on('click', '.k-event', function (e) {
                if (!$(e.target).hasClass('btn')) {
                    var $this = $(this);

                    if ($this.closest('.k-scheduler-yearview').length) {
                        $('.k-event').removeClass('z-index-1');
                        $this.addClass('z-index-1');
                    }

                    if (($this.find('.k-event-block').outerHeight() <= $this.outerHeight()) && !$this.hasClass('h-auto')) {
                        return;
                    }

                    var $wrapper = $this.closest('.k-scheduler-header, .k-scheduler-custom-time-line-viewview');

                    if ($this.hasClass('h-auto')) {
                        $scheduler.find('.h-auto').removeClass('h-auto');
                        $wrapper.removeClass('overflow-visible');
                    }
                    else {
                        $scheduler.find('.h-auto').removeClass('h-auto');
                        $this.addClass('h-auto');
                        $wrapper.addClass('overflow-visible');
                    }
                }
            });

            $scheduler.on('click', function (e) {
                if (!$(e.target).closest('.k-event').length) {
                    $('.k-scheduler .h-auto').removeClass('h-auto');
                    $('.k-scheduler .overflow-visible').removeClass('overflow-visible');
                }
            });

            $(window).on('resize orientationchange', function () {
                clearTimeout(self.resizeTimeout);
                self.resizeTimeout = setTimeout(function () {
                    self.calculateEventsHeight($scheduler);
                    self.checkWidth($scheduler);
                    setTimeout(function () {
                        self.reCalculateCalendarHeight($scheduler);
                    }, 150);
                }, 150);
            });
        },

        recalculate: function ($scheduler) {
            XPortal.Calendar.calculateEventsHeight($scheduler);
            XPortal.Calendar.checkWidth($scheduler);
            XPortal.Calendar.reCalculateCalendarHeight($scheduler);
        },

        calculateEventsHeight: function ($scheduler) {
            $scheduler.find('.k-event').each(function () {
                var $this = $(this);
                if ($this.find('.k-event-block').outerHeight() <= $this.outerHeight())
                    $this.removeClass('not-enough-height');
                else $this.addClass('not-enough-height');
            });
        },

        Init: function (xcontrol, options) {
            var result = new $.Deferred();
            if (options.views.length === 0) return result.resolve(console ? console.log("can't construct calendar: there is no views", xcontrol) : null);
            xcontrol = $(xcontrol);
            if (xcontrol.length < 1) return result.resolve();
            options.url = xcontrol.attr("data-src");
            self.weekCountItems = options.groupCount["week"];
            self.dayCountItems = options.groupCount["day"];
            var ranges = XPortal.Calendar.getDefaultRange(options.views[0]);
            var postData = XPortal.Calendar.createPostData(options.entityAlias, options.calendarId, options.pageSize, options.bindField, options.endDateField, ranges);
            self.startDayHour = options.startDayHour;
            self.endDayHour = options.endDayHour;
            self.dictionaryOptions[options.calendarId] = options;

            self.getData(postData, options.url, xcontrol).then(function (data) {
                result.resolve(XPortal.Calendar.initialiseCalendar(data, options));
            }).fail(function (xhr, ajaxOptions, thrownError) {
                console.log(xhr, ajaxOptions, thrownError);
            });
            return result;
        },

        getData: function (postData, url, schedulerObj) {
            var headers = {};
            if (schedulerObj)
                $.each(schedulerObj.closest(".scheduler-parent").children("input:hidden"), function (ix, ixel) {
                    var xel = $(ixel);
                    if (xel.attr("name")) headers[xel.attr("name")] = xel.val();
                });
            if (!headers["RequestVerificationToken"]) headers["RequestVerificationToken"] = XPortal.Main.getAntiForgeryToken();
            return $.ajax({ url: XPortal.Utils.EnsureInProfile(url), type: 'POST', dataType: 'json', headers: headers, data: postData });
        },

        createPostData: function (entityAlias, nodeId, pageSize, bindField, endDateField, range, pageIndex, parentElementId, parentNodeId) {
            var postData = {
                model: {
                    EntityAlias: entityAlias,
                    NodeId: nodeId,
                    PageIndex: (pageIndex == null) ? 1 : pageIndex,
                    PageSize: (pageSize === 0) ? 100000 : pageSize,
                    ElementIds: [parentElementId],
                    ParentNodeId: parentNodeId,
                    Filter: {
                        Filters: [
                            { value: range.end, operator: "lte", field: bindField.toLowerCase() },
                            { value: range.start, operator: "gte", field: endDateField.toLowerCase() }
                        ],
                        Logic: "and"
                    }
                }
            };
            return postData;
        },

        GetDataByParentInfo: function (parentElementId, parentNodeId, calendarId, url, ranges, pageIndex, pageSize, element) {
            var coptions = self.dictionaryOptions[calendarId];
            var entityAlias = coptions.entityAlias;
            coptions.parentElementId = parentElementId;
            coptions.parentNodeId = parentNodeId;
            coptions.calendarChildUrl = url;

            var postData = self.createPostData(entityAlias, calendarId, pageSize, coptions.bindField, coptions.endDateField, ranges, pageIndex, parentElementId, parentNodeId);
            return self.getData(postData, url, element);
        },
        firstVisibleMonthDay: function (date, calendarInfo) {
            var firstDay = calendarInfo.firstDay, firstVisibleDay = new Date(date.getFullYear(), date.getMonth(), 1, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
            while (firstVisibleDay.getDay() !== firstDay) {
                kendo.date.setTime(firstVisibleDay, -1 * self.MS_PER_DAY);
            }

            return firstVisibleDay;
        },

        sortByDuring: function (data, bindField, endDateField) {
            for (var i = 0; i < data.length; i++) {
                var dateStart = data[i].start;
                var dateEnd = data[i].end;
                var diffTime = Math.abs(dateEnd.getTime() - dateStart.getTime());
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                data[i].durationInDays = diffDays;
            }

            data.sort(XPortal.Calendar.compare);
        },

        compare: function compare(a, b) {
            if (a.durationInDays < b.durationInDays) {
                return -1;
            }
            if (a.durationInDays > b.durationInDays) {
                return 1;
            }
            return 0;
        },

        generateColors: function (count, colors) {
            var result = [];
            if (colors === null) {
                for (j = 0; j < count; j++) {
                    result.push("rgb(76, 132, 227)");
                }
                return result;
            }
            var iterator = colors.values();
            for (i = 0; i < count; i++) {
                var color = iterator.next();
                if (color.value !== undefined) result.push(color.value);
                else {
                    iterator = colors.values();
                    color = iterator.next().value;
                    result.push(color);
                }
            }
            return result;
        },
        extendForCalendar: function (data, countItems, bindField, itemMinutes, endDateField, detailGridLink, calendarId, bgColor, colorField, dateFormat, colors) {
            var dataArray = [];
            countItems = (countItems === 0) ? data.length : countItems;
            var itemColors = XPortal.Calendar.generateColors(data.length, colors);
            for (var i = 0; i < data.length; i++) {
                if (i > countItems) { continue; }

                var dateStartStr = data[i][bindField.toLowerCase()] ? new Date(data[i][bindField.toLowerCase()]) : dateStartStr;
                data[i].start = XPortal.Calendar.isInvalidDate(dateStartStr) ? moment(data[i].Created)._d : moment(dateStartStr).add(1, 'milliseconds')._d;

                var dateEndStr = data[i][endDateField.toLowerCase()] ? new Date(data[i][endDateField.toLowerCase()]) : dateEndStr;
                if (dateEndStr == null) data[i].end = data[i].start;
                else data[i].end = XPortal.Calendar.isInvalidDate(dateEndStr) ? data[i].start : moment(dateEndStr).add(-1, 'milliseconds')._d;

                data[i] = XPortal.Calendar.changeDateFormat(data[i], dateFormat);

                data[i].href = detailGridLink + "?id=" + data[i].UniqueId + "&r=" + XPortal.Utils.guid() + "&bc=" + calendarId;

                //replace all #=model.href# in data[i] fields which ends with template
                $.each(data[i], function (key, value) {
                    if (!key.endsWith("template")) return;
                    data[i][key] = value.replace("#=model.href#", data[i].href);
                });

                data[i].color = itemColors[i];
                if (data[i].start < data[i].end) {
                    dataArray.push(data[i]);
                }
                else {
                    console.warn("End date less that Start date for object: " + JSON.stringify(data[i].Json));
                }
            }

            return dataArray;
        },

        changeDateFormat: function (obj, dateFormat) {
            var keys = Object.keys(obj);

            for (var j = 0; j < keys.length; j++) {
                if (keys[j] === "start" || keys[j] === "end") continue;
                var value = obj[keys[j]];
                if (XPortal.Calendar.isInvalidDate(value)) {
                    obj[keys[j]] = kendo.toString(value, dateFormat);
                }
            }

            return obj;
        },

        isInvalidDate: function (date) {
            return !(date instanceof Date && !isNaN(date));
        },

        updateDataSource: function (data, uiData) {
            var options;
            var dataGrid = !(data.Result) ? [] : data.Result.Items.map(di => XPortal.Grid.MapEntity(di, options));
            var dataArray = XPortal.Calendar.extendForCalendar(dataGrid, uiData.countItems, uiData.bindField, uiData.itemMinutes, uiData.endDateField, uiData.detailGridLink, uiData.calendarId, uiData.bgColor, uiData.colorField, uiData.dateFormat, uiData.XPortalGridActionColors);
            XPortal.Calendar.sortByDuring(dataArray, uiData.bindField, uiData.endDateField);

            var dataSource = new kendo.data.DataSource({ data: dataArray });
            var calendarView = $("#calendar-" + uiData.calendarId).data("kendoScheduler");
            calendarView.dataSource.data(dataArray);
        },

        getKeyByValue: function (views, value) {
            return Object.keys(views).find(key => views[key] === value);
        },

        initialiseCalendar: function (data, uiData) {
            var options;
            var dataGrid = !(data.Result) ? [] : data.Result.Items.map(di => XPortal.Grid.MapEntity(di, options));
            var dataArray = XPortal.Calendar.extendForCalendar(dataGrid, uiData.countItems, uiData.bindField, uiData.itemMinutes, uiData.endDateField, uiData.detailGridLink, uiData.calendarId, uiData.bgColor, uiData.colorField, uiData.dateFormat, uiData.XPortalGridActionColors);
            XPortal.Calendar.sortByDuring(dataArray, uiData.bindField, uiData.endDateField);

            var views = [];

            for (var i = 0; i < uiData.views.length; i++) {
                var tmpFunk = self.views[uiData.views[i]];
                var viewObj = {
                    title: uiData.titles[uiData.views[i]],
                    type: tmpFunk && {}.toString.call(tmpFunk) === '[object Function]' ? self.views[uiData.views[i]](uiData) : tmpFunk,
                    name: uiData.views[i]
                };
                views.push(viewObj);
            }

            var indexOfDay = XPortal.GridCalendar.daysOfWeek.indexOf(uiData.startDay);
            if (indexOfDay >= 0) {
                kendo.culture().calendar.firstDay = indexOfDay;
            }

            var $calendarObj = $("#calendar-" + uiData.calendarId);
            $calendarObj.kendoScheduler($.extend(true, {
                init: self.checkWidth($calendarObj),
                height: self.calculateCalendarHeight($calendarObj[0]),
                date: kendo.date.today(),
                showWorkHours: uiData.showWorkHours,
                workDayStart: new Date(1980, 1, 1, self.startDayHour, 0, 0),
                workDayEnd: new Date(1980, 1, 1, self.endDayHour, 0, 0),
                views: views,
                allDayEventTemplate: $("#event-template-" + uiData.calendarId).html(),
                editable: uiData.editable || false,
                selectable: uiData.selectable,
                selectedShortDateFormat: "{0:D}",
                eventTemplate: $("#event-template-" + uiData.calendarId).html(),
                dataSource: dataArray,
                footer: {
                    command: false
                },
                navigate: function (e) {
                    var calendarView = $("#calendar-" + uiData.calendarId).data("kendoScheduler");

                    XPortal.Loader.show({ selector: calendarView.element });

                    if (e.view === "undefined" && views.length > 0) e.view = views[0].title;
                    if (e.action === "changeView") {
                        calendarView.select(null);
                        calendarView.view(e.view);
                        e.preventDefault();
                        calendarView.date(e.date);
                    }

                    var nameOfView = XPortal.Calendar.getKeyByValue(uiData.titles, e.view) || calendarView._selectedViewName;
                    var dateRangeStrtegy = XPortal.Calendar.resolveDateRangeStrategy((nameOfView === undefined) ? e.view : nameOfView);
                    var edate = e.date ? e.date : new Date((calendarView._selectedView._startDate.getTime() + calendarView._selectedView._endDate.getTime()) / 2); // get milliseconds

                    var ranges = dateRangeStrtegy(edate);
                    var options = self.dictionaryOptions[uiData.calendarId];
                    var postData = XPortal.Calendar.createPostData(uiData.entityAlias, uiData.calendarId, uiData.pageSize, uiData.bindField, uiData.endDateField, ranges, null, options.parentElementId, options.parentNodeId);
                    if (options != null && options.parentElementId != null && options.parentNodeId != null && options.calendarChildUrl != null) {
                        self.GetDataByParentInfo(options.parentElementId, options.parentNodeId, uiData.calendarId, options.calendarChildUrl, ranges, options.PageIndex, options.PageSize || uiData.pageSize, $calendarObj).then(function (data) {
                            self.updateDataSource(data, options);
                            XPortal.Loader.hide({ selector: calendarView.element });
                            self.calculateEventsHeight($calendarObj);
                        });
                    }
                    else {
                        self.getData(postData, uiData.url, calendarView.element).then(function (data) {
                            self.updateDataSource(data, uiData);
                            XPortal.Loader.hide({ selector: calendarView.element });
                            self.calculateEventsHeight($calendarObj);
                        });
                    }
                    if (uiData.onXNavigate) uiData.onXNavigate(e, calendarView);
                },
                messages: {
                    today: uiData.messages.today
                }
            }, uiData.kendoScheduller));

            $calendarObj.on("dblclick", function (e) {
                if (uiData.detailGridLink === "") {
                    console.error("Detail page not defined");
                    return;
                }

                var calendarView = $(this).getKendoScheduler();
                var element = $(e.target).is(".k-event") ? $(e.target) : $(e.target).closest(".k-event");
                if (element.length === 0) {
                    element = $(e.target).is(".k-today") ? $(e.target) : $(e.target).closest(".k-today");
                    if (element.length === 0) {
                        return;
                    }
                }

                var id;
                if (calendarView.view().name === "year") {
                    id = element[0].dataset.uid;
                }
                else {
                    var event = calendarView.occurrenceByUid(element.data("uid"));
                    id = event.UniqueId;
                }

                var newGuid = XPortal.Utils.guid();
                var gridDetailUrl = uiData.detailGridLink + "?id=" + id +
                    "&r=" + newGuid +
                    "&bc=" + uiData.calendarId;

                window.location.href = gridDetailUrl;
            });

            var tooltip = $calendarObj.kendoTooltip({
                autoHide: false,
                show: function (e) {
                    this.popup.element.addClass('calendar-tooltip');
                },
                _showOn: function (e) {
                    e.preventDefault();
                },
                filter: ".k-event:not(:has(.k-event-block.group))",
                content: kendo.template($("#template" + uiData.calendarId).html()),
                position: "top",
                offset: 0
            }).data("kendoTooltip");

            $calendarObj.on("click", function (e) {
                var buttonElement = $(e.target).is(".btn-primary") ? $(e.target) : $(e.target).closest(".btn-primary");
                var buttonElementRef = $(e.target).is(".btn-primary-ref") ? $(e.target) : $(e.target).closest(".btn-primary-ref");

                if (buttonElement.length !== 0 || buttonElementRef.length !== 0) {
                    element = $(e.target).is(".k-event") ? $(e.target) : $(e.target).closest(".k-event");
                    tooltip.show(element);
                }

                var gridElement = $(e.target).is(".btn-grid") ? $(e.target) : $(e.target).closest(".btn-grid");
                if (gridElement.length !== 0) {
                    element = $(e.target).is(".k-event") ? $(e.target) : $(e.target).closest(".k-event");

                    var slot = {
                        startDate: new Date($(element).attr("start-date")),
                        endDate: new Date($(element).attr("end-date"))
                    };

                    var href = uiData.gridLink + "?hshqf=" + uiData.calendarId + "~" + slot.startDate.toUTCString() + "~" + slot.endDate.toUTCString();
                    window.location.href = href;
                }
            });

            self.bindEvents($calendarObj);
            setTimeout(function () {
                self.calculateEventsHeight($calendarObj);
            }, 0);
            setTimeout(function () {
                self.reCalculateCalendarHeight($calendarObj);
            }, 1000);
            return $calendarObj;
        },

        reCalculateCalendarHeight: function ($calendar) {
            let calendarData = $calendar.data('kendoScheduler');
            calendarData.element.height(self.calculateCalendarHeight($calendar[0]));
            calendarData.refresh();
        },

        calculateCalendarHeight: function (calendar) {
            const wrpMinHeight = calendar.closest('[data-minheight]');
            const wrpHeight = calendar.closest('[data-height]');
            const wrpMaxHeight = calendar.closest('[data-maxheight]');
            let wrp = wrpMinHeight || wrpHeight || wrpMaxHeight;
            if (!wrp) {
                calendar.classList.add('d-none');
                wrp = calendar.closest('.scheduler-parent');
                const wrpHeight = $(wrp).height();
                wrpHeight < 250 && (wrp = calendar.closest('.content-wrapper'));
                let height = Math.max(250, $(wrp).height()) - self.checkAddHeight(wrp);
                calendar.classList.remove('d-none');

                if ($(calendar).parents('.tab-pane')) {
                    // Adjust height for calendar in tabs, as the default height (612px) is set for infrequent use cases
                    height = 612;
                }
                
                var sectionHeight = self.scheckForSectionHeight($(calendar));
                (sectionHeight && sectionHeight > height) && (height = sectionHeight);

                return height;
            }

            const minheight = wrpMinHeight ? parseInt(wrpMinHeight.getAttribute('data-minheight')) : 0;
            const height = wrpHeight ? parseInt(wrpHeight.getAttribute('data-height')) : 0;
            const maxheight = wrpMaxHeight ? parseInt(wrpMaxHeight.getAttribute('data-maxheight')) : 0;

            let resultHeight = Math.max(
                250,
                Math.min(...([height, maxheight].filter(el => { return el > 0 }))),
                minheight
            );

            var sectionHeight = self.scheckForSectionHeight($(calendar));
            (sectionHeight && sectionHeight > resultHeight) && (resultHeight = sectionHeight)

            return resultHeight - self.checkAddHeight(wrpMinHeight || wrpHeight || wrpMaxHeight);
        },

        checkAddHeight: function (heightWrapper) {
            if (!heightWrapper)
                return;

            let addHeight = 22; //scrollbar height

            const header = heightWrapper.querySelectorAll('.block-header');
            header.forEach(item => {
                addHeight += $(item).outerHeight(true);
            });

            const label = heightWrapper.querySelector('.rich-text-label');
            label && (addHeight += $(label).outerHeight(true));

            return addHeight;
        },

        scheckForSectionHeight: function ($calendar) {
            var additionalHeight = 0;
            var $sectionWrp = $calendar.closest('.xsection');
            if ($sectionWrp.length && $sectionWrp.hasClass('maximizible') || $sectionWrp.hasClass('collapsible')) {
                var $blockHeader = $sectionWrp.find('.block-header');
                $blockHeader.length && (additionalHeight += $blockHeader.outerHeight());
                var $collapseButtons = $('.collapse-buttons');
                ($collapseButtons.length && !$blockHeader.length) && (additionalHeight += $collapseButtons.outerHeight());

                var height = $sectionWrp.outerHeight();

                !$sectionWrp.hasClass('maximized') && $sectionWrp.css({ 'height': '' });

                return height - additionalHeight - 20;
            } else {
                var height = $sectionWrp.outerHeight() - 20;
                return height;
            }
        },

        checkWidth: function ($scheduler) {
            var $schWidth = $scheduler.outerWidth();
            if ($schWidth <= 1024) {
                $scheduler.addClass('scheduler-mobile-view');
                if ($schWidth <= 480) {
                    $scheduler.addClass('scheduler-extra-mobile-view');
                }
                else {
                    $scheduler.removeClass('scheduler-extra-mobile-view');
                }
            } else {
                $scheduler.removeClass('scheduler-mobile-view').removeClass('scheduler-extra-mobile-view');
            }
        },

        resolveDateRangeStrategy: function (view) {
            switch (view) {
                case 'day':
                case 'timeline':
                    return XPortal.Calendar.timeLineRangeStrategy
                case 'timelineweek':
                case 'week':
                    return XPortal.Calendar.timelineWeekRangeStrategy
                case 'month':
                case 'kendo.ui.MonthCustomView':
                case 'monthColumn':
                    return XPortal.Calendar.monthRangeStrategy
                case 'kendo.ui.YearView':
                case 'year':
                    return XPortal.Calendar.yearRangeStrategy
                default:
                    console.log('Sorry, we are out of range');
            }
        },

        yearRangeStrategy: function (changeDate) {
            return XPortal.Calendar.getYearPeriodTimeZoneAdapted(changeDate);
        },

        monthRangeStrategy: function (changeDate) {
            return XPortal.Calendar.getMonthPeriodTimeZoneAdapted(changeDate);
        },

        timelineWeekRangeStrategy: function (changeDate) {

            return XPortal.Calendar.getWeekPeriodTimeZoneAdapted(changeDate);
        },

        timeLineRangeStrategy: function (changeDate) {
            return XPortal.Calendar.getDayPeriodTimeZoneAdapted(changeDate)
        },

        getDefaultRange: function (view) {
            var today = new Date();
            view = view && view.length ? view : "week";
            switch (view) {
                case 'day':
                case 'timeline':
                    return XPortal.Calendar.getDayPeriodTimeZoneAdapted(today);
                case 'timelineweek':
                case 'week':
                    return XPortal.Calendar.getWeekPeriodTimeZoneAdapted(today);
                case 'month':
                case 'kendo.ui.MonthCustomView':
                case 'monthColumn':
                    return XPortal.Calendar.getMonthPeriodTimeZoneAdapted(today);
                case 'kendo.ui.YearView':
                case 'year':
                    return XPortal.Calendar.getYearPeriodTimeZoneAdapted(today);
                default:
                    console.log('Sorry, we are out of range');
            }
        },

        _groupEventsByStartDate: function (events, view) {
            var list = [];
            var length = events.length;
            for (var idx = 0; idx < length; idx++) {
                var event = events[idx];
                var isMultiDayEvent = event.isAllDay || event.end.getTime() - event.start.getTime() >= self.MS_PER_DAY || event.start.toDateString() !== event.end.toDateString();
                if (!isMultiDayEvent && view === "day") {
                    if (!list[event.start.toDateString()]) {
                        list[event.start.toDateString()] = [];
                    }
                    list[event.start.toDateString()].push(event);
                }
                else if (!isMultiDayEvent && view === "week") {
                    if (!list[event.start.toDateString()]) {
                        list[event.start.toDateString()] = [];
                    }
                    list[event.start.toDateString()].push(event);
                }
                else if (!isMultiDayEvent) {
                    if (!list[event.start.toDateString()]) {
                        list[event.start.toDateString()] = [];
                    }
                    event.start = new Date(event.start.getFullYear(), event.start.getMonth(), event.start.getDate(), 0, 0, 0);
                    event.end = new Date(event.end.getFullYear(), event.end.getMonth(), event.end.getDate(), 23, 59, 59);
                    list[event.start.toDateString()].push(event);
                }
                else if (isMultiDayEvent) {
                    event.start = new Date(event.start.getFullYear(), event.start.getMonth(), event.start.getDate(), 0, 0, 0);
                    event.end = new Date(event.end.getFullYear(), event.end.getMonth(), event.end.getDate(), 23, 59, 59);
                }
            }
            return list;
        },

        _groupEventsByHours: function (events) {
            var result = [];
            var dateKeys = Object.keys(events);
            for (keyIndex = 0; keyIndex < dateKeys.length; keyIndex++) {
                result[dateKeys[keyIndex]] = [];
                var items = events[dateKeys[keyIndex]];
                for (j = 0; j < items.length; j++) {
                    var item = items[j];
                    var diff = Math.abs(item.start - item.end);
                    var duration = Math.floor((diff / 1000) / 60);
                    items[j].durationMinutes = duration;
                }

                var sortedObjs = _.sortBy(items, 'durationMinutes');

                while (sortedObjs.length !== 0) {
                    var element = sortedObjs.pop();
                    var itemsInRange = XPortal.GridCalendar.DateRangeArayOverlaps(sortedObjs, element.start, element.end);

                    for (index = 0; index < itemsInRange.length; index++) {
                        var event = itemsInRange[index];
                        for (var idx = 0; idx < sortedObjs.length; idx++) {
                            if (sortedObjs[idx].uid == event.uid) {
                                sortedObjs.splice(idx, 1);
                                break;
                            }
                        }
                    }

                    itemsInRange.push(element);
                    result[dateKeys[keyIndex]].push(itemsInRange);
                }
            }
            return result;
        },


        addContinuousEvent: function (group, range, element, isAllDay) {
            var events = group._continuousEvents;
            var lastEvent = events[events.length - 1];
            var startDate = kendo.date.getDate(range.start.startDate()).getTime();
            if (isAllDay && lastEvent && kendo.date.getDate(lastEvent.start.startDate()).getTime() == startDate) {
                var idx = events.length - 1;
                for (; idx > -1; idx--) {
                    if (events[idx].isAllDay || kendo.date.getDate(events[idx].start.startDate()).getTime() < startDate) {
                        break;
                    }
                }
                events.splice(idx + 1, 0, {
                    element: element,
                    isAllDay: true,
                    uid: element.attr(kendo.attr('uid')),
                    start: range.start,
                    end: range.end
                });
            } else {
                events.push({
                    element: element,
                    isAllDay: isAllDay,
                    uid: element.attr(kendo.attr('uid')),
                    start: range.start,
                    end: range.end
                });
            }
        },

        _getRenderEventFunction: function () {
            return self._renderEvents;
        },


        getTimeFromMins: function (mins) {
            if (mins >= 24 * 60 || mins < 0) {
                throw new RangeError("Valid input should be greater than or equal to 0 and less than 1440.");
            }
            var h = mins / 60 | 0,
                m = mins % 60 | 0;
            return moment.utc().hours(h).minutes(m).format("hh:mm");
        },
        getDayPeriodTimeZoneAdapted: function (changeDate) {
            var userOffset = XPortal.Utils.getMemberTzOffset(self);

            var year = changeDate.getFullYear();
            var month = changeDate.getMonth() + 1;
            var day = changeDate.getDate();

            var formatedOffset = (userOffset < 0 ? "-" : "+") + XPortal.Calendar.getTimeFromMins(userOffset < 0 ? userOffset * -1 : userOffset);
            var startDateObj = moment(year + "." + month + "." + day + "T00:00:00" + formatedOffset, "YYYY.MM.DDThh:mm:ss Z");
            var startDate = startDateObj.toISOString();

            var endDateObj = moment(year + "." + month + "." + day + "T23:59:59" + formatedOffset, "YYYY.MM.DDThh:mm:ss Z");
            var endDate = endDateObj.toISOString();

            return {
                start: startDate,
                end: endDate
            };
        },
        getWeekPeriodTimeZoneAdapted: function (changeDate, startDay) {
            var userOffset = XPortal.Utils.getMemberTzOffset(self);

            var year = changeDate.getFullYear();
            var month = changeDate.getMonth() + 1;

            var tmpDay = changeDate.getDate() - kendo.culture().calendar.firstDay;
            var tmpDate = new Date(changeDate.getFullYear(), changeDate.getMonth(), tmpDay, 0, 0, 0);

            var startDay = tmpDate.getDate() - tmpDate.getDay() + (startDay ? startDay : kendo.culture().calendar.firstDay);
            var endDay = startDay + 6;

            var formatedOffset = (userOffset < 0 ? "-" : "+") + XPortal.Calendar.getTimeFromMins(userOffset < 0 ? userOffset * -1 : userOffset);
            var startDateObj = moment(year + "." + month + "." + startDay + "T00:00:00" + formatedOffset, "YYYY.MM.DDThh:mm:ss Z");
            var startDate = startDateObj.toISOString();

            var endDateObj = moment(year + "." + month + "." + endDay + "T23:59:59" + formatedOffset, "YYYY.MM.DDThh:mm:ss Z");
            var endDate = endDateObj.toISOString();

            return {
                start: startDate,
                end: endDate
            };
        },
        getMonthPeriodTimeZoneAdapted: function (changeDate) {
            var userOffset = XPortal.Utils.getMemberTzOffset(self);

            var year = changeDate.getFullYear();
            var month = changeDate.getMonth() + 1;

            var formatedOffset = (userOffset < 0 ? "-" : "+") + XPortal.Calendar.getTimeFromMins(userOffset < 0 ? userOffset * -1 : userOffset);
            var startDateObj = moment(year + "." + month + "." + "01T00:00:00" + formatedOffset, "YYYY.MM.DDThh:mm:ss Z");
            var startDate = startDateObj.toISOString();

            var endDateObj = moment(year + "." + month + "." + moment(year + "-" + month, "YYYY-MM").daysInMonth() + "T23:59:59" + formatedOffset, "YYYY.MM.DDThh:mm:ss Z");
            var endDate = endDateObj.toISOString();

            return {
                start: startDate,
                end: endDate
            };
        },

        getYearPeriodTimeZoneAdapted: function getYearPeriodTimeZoneAdapted(changeDate) {
            var userOffset = XPortal.Utils.getMemberTzOffset(self);
            var year = changeDate.getFullYear();
            var formatedOffset = (userOffset < 0 ? "-" : "+") + XPortal.Calendar.getTimeFromMins(userOffset < 0 ? userOffset * -1 : userOffset);

            var startDateObj = moment(year + ".01." + "01T00:00:00" + formatedOffset, "YYYY.MM.DDThh:mm:ss Z");
            var startDate = startDateObj.toISOString();

            var endDateObj = moment(year + ".12." + moment(year + "-12", "YYYY-MM").daysInMonth() + "T23:59:59" + formatedOffset, "YYYY.MM.DDThh:mm:ss Z");
            var endDate = endDateObj.toISOString();

            return {
                start: startDate,
                end: endDate
            };
        },

        views: {
            "day": function (ioptions) {
                var options = $.extend(true, {
                    name: "custom-day-view",
                    _renderEvents: function (events, groupIndex) {
                        var allDayEventContainer = this.datesHeader.find('.k-scheduler-header-wrap > div');
                        var byDate = this._isGroupedByDate();
                        var event;
                        var idx;
                        var length;
                        var groupsByDate = self._groupEventsByStartDate(events, "day");
                        for (idx = 0, length = events.length; idx < length; idx++) {
                            event = events[idx];
                            if (this._isInDateSlot(event)) {

                                var isMultiDayEvent = event.isAllDay || event.end.getTime() - event.start.getTime() >= self.MS_PER_DAY || event.start.toDateString() !== event.end.toDateString();

                                var container = isMultiDayEvent && !this._isVerticallyGrouped() ? allDayEventContainer : this.content;
                                var element, ranges, range, start, end, group;


                                if (!isMultiDayEvent) {

                                    if (this._isInTimeSlot(event)) {
                                        group = this.groups[groupIndex];
                                        if (!group._continuousEvents) {
                                            group._continuousEvents = [];
                                        }
                                        ranges = group.slotRanges(event);
                                        var rangeCount = ranges.length;
                                        for (var rangeIndex = 0; rangeIndex < rangeCount; rangeIndex++) {
                                            range = ranges[rangeIndex];
                                            start = event.start;
                                            end = event.end;
                                            if (rangeCount > 1) {
                                                if (rangeIndex === 0) {
                                                    end = range.end.endDate();
                                                } else if (rangeIndex == rangeCount - 1) {
                                                    start = range.start.startDate();
                                                } else {
                                                    start = range.start.startDate();
                                                    end = range.end.endDate();
                                                }
                                            }
                                            var occurrence = event.clone({
                                                start: start,
                                                end: end,
                                                _startTime: event._startTime,
                                                _endTime: event.endTime
                                            });
                                            if (this._isInTimeSlot(occurrence)) {
                                                var head = range.head;
                                                element = this._createEventElement(event, !isMultiDayEvent, head, range.tail);

                                                element.find(".group").remove();
                                                element.appendTo(container);
                                                this._positionEvent(occurrence, element, range);
                                                self.addContinuousEvent(group, range, element, false);
                                            }
                                        }
                                    }
                                } else if (this.options.allDaySlot) {
                                    group = this.groups[groupIndex];
                                    if (!group._continuousEvents) {
                                        group._continuousEvents = [];
                                    }
                                    ranges = group.slotRanges(event);
                                    if (ranges.length) {
                                        range = ranges[0];
                                        var startIndex = range.start.index;
                                        var endIndex = range.end.index;
                                        if (byDate && startIndex !== endIndex) {
                                            start = range.start.start;
                                            end = range.end.end;
                                            var newStart = new Date(start);
                                            var newEnd = new Date(start);
                                            for (var i = range.start.index; i <= range.end.index; i++) {
                                                element = this._createEventElement(event, !isMultiDayEvent, i !== endIndex, i !== startIndex);
                                                var dateRange = group.daySlotRanges(newStart, newEnd, true)[0];
                                                newEnd.setDate(newEnd.getDate() + 1);
                                                newStart.setDate(newStart.getDate() + 1);
                                                this._positionAllDayEvent(element, dateRange);
                                                self.addContinuousEvent(group, dateRange, element, true);
                                                element.appendTo(container);
                                            }
                                        } else {
                                            element = this._createEventElement(event, !isMultiDayEvent);
                                            element.find(".group").remove();
                                            this._positionEvent(event, element, ranges[0]);
                                            self.addContinuousEvent(group, ranges[0], element, true);
                                            element.appendTo(container);
                                        }
                                    }
                                }
                            }
                        }
                    },
                    _createEventElement: function (event, isOneDayEvent, head, tail, events) {
                        var template = isOneDayEvent ? this.eventTemplate : this.allDayEventTemplate;
                        var options = this.options;
                        var editable = options.editable;
                        var isMobile = this._isMobile();
                        var showDelete = editable && editable.destroy !== false && !isMobile;
                        var resizable = editable && editable.resize !== false;
                        var startDate = kendo.date.getDate(this.startDate());
                        var endDate = kendo.date.getDate(this.endDate());
                        var startTime = kendo.date.getMilliseconds(this.startTime());
                        var endTime = kendo.date.getMilliseconds(this.endTime());
                        var eventStartTime = event._time('start');
                        var eventEndTime = event._time('end');
                        var middle;
                        if (startTime >= endTime) {
                            endTime = kendo.date.getMilliseconds(new Date(this.endTime().getTime() + self.MS_PER_DAY - 1));
                        }
                        if (!isOneDayEvent && !event.isAllDay) {
                            endDate = new Date(endDate.getTime() + self.MS_PER_DAY);
                        }
                        var eventStartDate = event.start;
                        var eventEndDate = event.end;
                        if (event.isAllDay) {
                            eventEndDate = kendo.date.getDate(event.end);
                        }
                        if (!kendo.date.isInDateRange(kendo.date.getDate(eventStartDate), startDate, endDate) && !kendo.date.isInDateRange(eventEndDate, startDate, endDate) || isOneDayEvent && eventStartTime < startTime && eventEndTime > endTime) {
                            middle = true;
                        } else if (kendo.date.getDate(eventStartDate) < startDate || isOneDayEvent && eventStartTime < startTime) {
                            tail = true;
                        } else if (eventEndDate > endDate && !isOneDayEvent || isOneDayEvent && eventEndTime > endTime) {
                            head = true;
                        }
                        var resources = this.eventResources(event);
                        if (event._startTime && eventStartTime !== kendo.date.getMilliseconds(event.start)) {
                            eventStartDate = new Date(eventStartTime);
                            eventStartDate = kendo.timezone.apply(eventStartDate, 'Etc/UTC');
                        }
                        if (event._endTime && eventEndTime !== kendo.date.getMilliseconds(event.end)) {
                            eventEndDate = new Date(eventEndTime);
                            eventEndDate = kendo.timezone.apply(eventEndDate, 'Etc/UTC');
                        }
                        if (events === undefined) {
                            events = [];
                        }
                        var data = jQuery.extend({}, {
                            ns: kendo.ns,
                            resizable: resizable,
                            showDelete: showDelete,
                            middle: middle,
                            head: head,
                            dataArray: events,
                            tail: tail,
                            singleDay: this._dates.length == 1,
                            resources: resources,
                            inverseColor: resources && resources[0] ? this._shouldInverseResourceColor(resources[0]) : false,
                            messages: options.messages
                        }, event, {
                            start: eventStartDate,
                            end: eventEndDate
                        });
                        var element = $(template(data));
                        this.angular('compile', function () {
                            return {
                                elements: element,
                                data: [{ dataItem: data }]
                            };
                        });
                        return element;
                    }
                    ,
                    options: {
                        messages: {
                            allDay: ioptions.messages.allDay
                        }
                    }
                }, ioptions);
                return kendo.ui.DayView.extend(options);
            },
            "timeline": function (ioptions) {
                return kendo.ui.TimelineView.extend($.extend(true, {
                    name: "custom-time-line-view",
                    options: {
                        eventHeight: 10,
                        columnWidth: 40,
                        messages: {
                            allDay: ioptions.messages.allDay
                        }
                    }
                }, ioptions));
            },
            "week": function (ioptions) {
                return kendo.ui.WeekView.extend($.extend(true, {
                    name: "custom-week-view",
                    _createEventElement: function (event, isOneDayEvent, head, tail, events) {
                        var template = isOneDayEvent ? this.eventTemplate : this.allDayEventTemplate;
                        var options = this.options;
                        var editable = options.editable;
                        var isMobile = this._isMobile();
                        var showDelete = editable && editable.destroy !== false && !isMobile;
                        var resizable = editable && editable.resize !== false;
                        var startDate = kendo.date.getDate(this.startDate());
                        var endDate = kendo.date.getDate(this.endDate());
                        var startTime = kendo.date.getMilliseconds(this.startTime());
                        var endTime = kendo.date.getMilliseconds(this.endTime());
                        var eventStartTime = event._time('start');
                        var eventEndTime = event._time('end');
                        var middle;
                        if (startTime >= endTime) {
                            endTime = kendo.date.getMilliseconds(new Date(this.endTime().getTime() + self.MS_PER_DAY - 1));
                        }
                        if (!isOneDayEvent && !event.isAllDay) {
                            endDate = new Date(endDate.getTime() + self.MS_PER_DAY);
                        }
                        var eventStartDate = event.start;
                        var eventEndDate = event.end;
                        if (event.isAllDay) {
                            eventEndDate = kendo.date.getDate(event.end);
                        }
                        if (!kendo.date.isInDateRange(kendo.date.getDate(eventStartDate), startDate, endDate) && !kendo.date.isInDateRange(eventEndDate, startDate, endDate) || isOneDayEvent && eventStartTime < startTime && eventEndTime > endTime) {
                            middle = true;
                        } else if (kendo.date.getDate(eventStartDate) < startDate || isOneDayEvent && eventStartTime < startTime) {
                            tail = true;
                        } else if (eventEndDate > endDate && !isOneDayEvent || isOneDayEvent && eventEndTime > endTime) {
                            head = true;
                        }
                        var resources = this.eventResources(event);
                        if (event._startTime && eventStartTime !== kendo.date.getMilliseconds(event.start)) {
                            eventStartDate = new Date(eventStartTime);
                            eventStartDate = kendo.timezone.apply(eventStartDate, 'Etc/UTC');
                        }
                        if (event._endTime && eventEndTime !== kendo.date.getMilliseconds(event.end)) {
                            eventEndDate = new Date(eventEndTime);
                            eventEndDate = kendo.timezone.apply(eventEndDate, 'Etc/UTC');
                        }
                        if (events === undefined) {
                            events = [];
                        }
                        var data = jQuery.extend({}, {
                            ns: kendo.ns,
                            resizable: resizable,
                            showDelete: showDelete,
                            middle: middle,
                            head: head,
                            dataArray: events,
                            tail: tail,
                            singleDay: this._dates.length == 1,
                            resources: resources,
                            inverseColor: resources && resources[0] ? this._shouldInverseResourceColor(resources[0]) : false,
                            messages: options.messages
                        }, event, {
                            start: eventStartDate,
                            end: eventEndDate
                        });
                        var element = $(template(data));
                        this.angular('compile', function () {
                            return {
                                elements: element,
                                data: [{ dataItem: data }]
                            };
                        });
                        return element;
                    },
                    _renderEvents: function (events, groupIndex) {
                        var allDayEventContainer = this.datesHeader.find('.k-scheduler-header-wrap > div');
                        var byDate = this._isGroupedByDate();
                        var event;
                        var idx;
                        var length;
                        var groupsByDate = self._groupEventsByStartDate(events, "week");
                        var groupsByHour = self._groupEventsByHours(groupsByDate);

                        var groupIds = [];
                        var dateKeys = Object.keys(groupsByHour);
                        for (dateIndex = 0; dateIndex < dateKeys.length; dateIndex++) {
                            var itemsInDay = groupsByHour[dateKeys[dateIndex]];
                            for (itemIndex = 0; itemIndex < itemsInDay.length; itemIndex++) {
                                var items = itemsInDay[itemIndex];
                                if (items.length > self.weekCountItems) {
                                    let ids = items.map(a => a.uid);
                                    groupIds = groupIds.concat(ids);
                                }
                            }
                        }

                        // render group events

                        for (dateIndex = 0; dateIndex < dateKeys.length; dateIndex++) {
                            var itemsInDay = groupsByHour[dateKeys[dateIndex]];
                            for (itemIndex = 0; itemIndex < itemsInDay.length; itemIndex++) {
                                var items = itemsInDay[itemIndex];
                                if (items.length > self.weekCountItems) {
                                    groupEvents = items;
                                    group = this.groups[groupIndex];
                                    if (!group._continuousEvents) {
                                        group._continuousEvents = [];
                                    }
                                    groupEvents = _.sortBy(groupEvents, 'durationMinutes').reverse();
                                    start = new Date(Math.min.apply(null, groupEvents.map(a => a.start)));
                                    end = new Date(Math.max.apply(null, groupEvents.map(a => a.end)));
                                    groupEvents[0].start = start;
                                    groupEvents[0].end = end;

                                    ranges = group.slotRanges(groupEvents[0]);
                                    var rangeCount = ranges.length;
                                    for (var rangeIndex = 0; rangeIndex < rangeCount; rangeIndex++) {
                                        range = ranges[rangeIndex];

                                        eventItem = groupEvents[0];
                                        var isMultiDayEvent = eventItem.isAllDay || eventItem.end.getTime() - eventItem.start.getTime() >= self.MS_PER_DAY || eventItem.start.toDateString() !== eventItem.end.toDateString();

                                        var container = isMultiDayEvent && !this._isVerticallyGrouped() ? allDayEventContainer : this.content;
                                        if (this._isInDateSlot(eventItem)) {

                                            if (rangeCount > 1) {
                                                if (rangeIndex === 0) {
                                                    end = range.end.endDate();
                                                } else if (rangeIndex == rangeCount - 1) {
                                                    start = range.start.startDate();
                                                } else {
                                                    start = range.start.startDate();
                                                    end = range.end.endDate();
                                                }
                                            }
                                            var occurrence = groupEvents[0].clone({
                                                start: start,
                                                end: end,
                                                _startTime: groupEvents[0]._startTime,
                                                _endTime: groupEvents[0].endTime
                                            });
                                            if (this._isInTimeSlot(occurrence)) {
                                                var head = range.head;
                                                element = this._createEventElement(eventItem, !isMultiDayEvent, head, range.tail, groupEvents);

                                                $(element).attr('start-date', new Date(Math.min.apply(null, groupEvents.map(a => a.start))));
                                                $(element).attr('end-date', new Date(Math.max.apply(null, groupEvents.map(a => a.end))));

                                                element.find(".alone").remove();
                                                element.appendTo(container);
                                                this._positionEvent(occurrence, element, range);
                                                self.addContinuousEvent(group, range, element, false);
                                            }
                                        }
                                    }
                                }
                            }
                        }


                        for (idx = 0, length = events.length; idx < length; idx++) {
                            event = events[idx];
                            if (groupIds.includes(event.uid)) continue;
                            if (this._isInDateSlot(event)) {

                                var isMultiDayEvent = event.isAllDay || event.end.getTime() - event.start.getTime() >= self.MS_PER_DAY || event.start.toDateString() !== event.end.toDateString();

                                var container = isMultiDayEvent && !this._isVerticallyGrouped() ? allDayEventContainer : this.content;
                                var element, ranges, range, start, end, group;


                                if (!isMultiDayEvent) {

                                    if (this._isInTimeSlot(event)) {
                                        group = this.groups[groupIndex];
                                        if (!group._continuousEvents) {
                                            group._continuousEvents = [];
                                        }
                                        ranges = group.slotRanges(event);
                                        var rangeCount = ranges.length;
                                        for (var rangeIndex = 0; rangeIndex < rangeCount; rangeIndex++) {
                                            range = ranges[rangeIndex];
                                            start = event.start;
                                            end = event.end;
                                            if (rangeCount > 1) {
                                                if (rangeIndex === 0) {
                                                    end = range.end.endDate();
                                                } else if (rangeIndex == rangeCount - 1) {
                                                    start = range.start.startDate();
                                                } else {
                                                    start = range.start.startDate();
                                                    end = range.end.endDate();
                                                }
                                            }
                                            var occurrence = event.clone({
                                                start: start,
                                                end: end,
                                                _startTime: event._startTime,
                                                _endTime: event.endTime
                                            });
                                            if (this._isInTimeSlot(occurrence)) {
                                                var head = range.head;
                                                element = this._createEventElement(event, !isMultiDayEvent, head, range.tail);
                                                element.find(".group").remove();
                                                element.appendTo(container);
                                                this._positionEvent(occurrence, element, range);
                                                self.addContinuousEvent(group, range, element, false);
                                            }
                                        }
                                    }
                                } else if (this.options.allDaySlot) {
                                    group = this.groups[groupIndex];
                                    if (!group._continuousEvents) {
                                        group._continuousEvents = [];
                                    }
                                    ranges = group.slotRanges(event);
                                    if (ranges.length) {
                                        range = ranges[0];
                                        var startIndex = range.start.index;
                                        var endIndex = range.end.index;
                                        if (byDate && startIndex !== endIndex) {
                                            start = range.start.start;
                                            end = range.end.end;
                                            var newStart = new Date(start);
                                            var newEnd = new Date(start);
                                            for (var i = range.start.index; i <= range.end.index; i++) {
                                                element = this._createEventElement(event, !isMultiDayEvent, i !== endIndex, i !== startIndex);
                                                var dateRange = group.daySlotRanges(newStart, newEnd, true)[0];
                                                newEnd.setDate(newEnd.getDate() + 1);
                                                newStart.setDate(newStart.getDate() + 1);
                                                this._positionAllDayEvent(element, dateRange);
                                                self.addContinuousEvent(group, dateRange, element, true);
                                                element.appendTo(container);
                                            }
                                        } else {
                                            element = this._createEventElement(event, !isMultiDayEvent);
                                            element.find(".group").remove();
                                            this._positionEvent(event, element, ranges[0]);
                                            self.addContinuousEvent(group, ranges[0], element, true);
                                            element.appendTo(container);
                                        }
                                    }
                                }
                            }
                        }
                    },
                    options: {
                        eventHeight: 10,
                        columnWidth: 40,
                        messages: {
                            allDay: ioptions.messages.allDay
                        }
                    }
                }, ioptions));
            },

            "month": function (ioptions) {
                return kendo.ui.MonthView.extend($.extend(true, {
                    name: "custom-month",
                    MORE_BUTTON_TEMPLATE: kendo.template(
                        '<div style="width:#=width#px;left:#=left#px;top:#=top#px" class="k-more-events k-button"><span>...</span></div>'
                    ),
                    _renderLayout: function (date) {
                        var that = this;
                        this._firstDayOfMonth = kendo.date.firstDayOfMonth(date);
                        this._lastDayOfMonth = kendo.date.lastDayOfMonth(date);
                        this._startDate = self.firstVisibleMonthDay(date, this.calendarInfo());
                        this.createLayout(this._layout());
                        this._content();
                        this.refreshLayout();
                        this.content.on('click' + self.NS, '.k-nav-day,.k-more-events', function (e) {
                            var offset = $(e.currentTarget).offset();
                            var slot = that._slotByPosition(offset.left, offset.top);
                            e.preventDefault();
                            var test = slot.startDate();
                            that.trigger('navigate', {
                                view: 'day',
                                date: slot.startDate(),
                                navButton: true
                            });
                        });
                        this.content.on('click' + self.NS, '.k-event a:has(.k-i-close)', function (e) {
                            that.trigger('remove', { uid: $(this).closest('.k-event').attr(kendo.attr('uid')) });
                            e.preventDefault();
                        });
                    }
                }, ioptions));
            },
            "year": "kendo.ui.YearView",
            "monthColumn": "kendo.ui.MonthCustomView"
        }
    };

    self.DebugTemplateEvent = function (a, ...others) {
        console.log("-mtd-", others);
        return a;
    };
    return self;
}());